export const UPDATE_FULFILLMENT_PLAN_ORDER_GRID_STATUS = 'UPDATE_FULFILLMENT_PLAN_ORDER_GRID_STATUS';
export const updateFulfillmentPlanOrderGridStatus = ({ fulfillmentPlanId, orderGridStatus }) => ({
  type: UPDATE_FULFILLMENT_PLAN_ORDER_GRID_STATUS,
  fulfillmentPlanId,
  orderGridStatus,
});
